// extracted by mini-css-extract-plugin
module.exports = {"list-menu-item-checkbox":"styles_list-menu-item-checkbox__RtyBu"};